import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../store/reducers';
import { isOptionActive } from '@dch/products-business-logic';
import {
  ClosePayAndGoModal,
  OrderPayAndGo,
} from '../../../store/actions/pay-and-go.actions';

declare let jQuery: any;
@Component({
  selector: 'mprd-pay-and-go-modal',
  templateUrl: './pay-and-go-modal.component.html',
})
export class PayAndGoModalComponent implements OnInit {
  public acceptTermsAndConditions;
  public option;
  public msisdn;
  public destroy: () => void;

  constructor(private store: Store<ApplicationState>) {}

  ngOnInit(): void {
    const bg = jQuery('.reveal-modal-bg');
    if (bg && bg.on && bg.off) {
      bg.off('click.mynamespace');
      bg.on('click.mynamespace', () => {
        this.close();
      });
    }
  }

  confirm() {
    if (isOptionActive(this.option)) {
      this.store.dispatch(
        new OrderPayAndGo({ msisdn: this.msisdn, proxiWorld: false }),
      );
      this.destroy();
    } else {
      this.store.dispatch(
        new OrderPayAndGo({
          msisdn: this.msisdn,
          proxiWorld: true,
        }),
      );
      this.destroy();
    }
  }

  close() {
    this.store.dispatch(new ClosePayAndGoModal());
    this.destroy();
  }
}
